// extracted by mini-css-extract-plugin
module.exports = {"content":"title-description-block_content__EoGF5"};